import { Typography } from '@mui/material';

export function EmptyValue() {
  return <Typography color="secondary.light">{'—'}</Typography>;
}
